import { useController } from 'react-hook-form';
import {
  MultiFilterSelect,
  MultiSelectProps,
  SelectValueType,
  FilterSelectProps,
} from 'ui/selects';
import { FieldProps } from './types';

export type MultiFilterSelectFieldProps<TValue extends SelectValueType = string> = FieldProps &
  Omit<FilterSelectProps<TValue, MultiSelectProps>, 'defaultValues' | 'isError' | 'onSelect'>;

export const MultiFilterSelectField = <TValue extends SelectValueType = string>({
  name,
  ...rest
}: MultiFilterSelectFieldProps<TValue>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue: '',
  });
  return (
    <MultiFilterSelect
      {...rest}
      isError={!!error}
      defaultValues={value}
      onSelect={(selectedValues) => onChange(selectedValues)}
    />
  );
};
